import Cookies from "js-cookie";
import { CheckoutPlan, decorateUrlWithUTMParams } from "../LandingPage";
import { getInternalCoreEndpoint } from "../utils";
import { sha256 } from "js-sha256";
import { User } from "../types";
import { LOCAL_STORAGE_SESSION_IDENTITY_SESSION_ID_KEY } from "./useAnswerTracker";

// quiz4 offer since 2026-09-10: no auto-applied promotion code. The 20% off is
// display-only (see getPlans); checkout rides the plain create-trial path.
export function getPlanPromotionCode(plan?: CheckoutPlan) {
  if (plan?.promotionCode) return plan.promotionCode;
  return undefined;
}

export function createGetClientSecretPromise(
  plan?: CheckoutPlan,
  eventID?: string,
  user?: User,
  isWeb17Variation?: boolean
) {
  const mode = "web";
  const subscriptionPriceId = plan?.priceId ?? "";
  const unlockProductId = plan?.unlockProductId ?? "";
  const trialProductId = plan?.trialProductId ?? "";

  const amplitudeId = Cookies.get("bws_amplitude_device_id");
  const sessionIdentitySessionId = localStorage.getItem(
      LOCAL_STORAGE_SESSION_IDENTITY_SESSION_ID_KEY
  );

  let urlObj: URL;
  const promotionCode = getPlanPromotionCode(plan);
  const web17_3DiscountId = plan?.experiments?.web17_3?.discount;
  const summerDiscountId = plan?.discount;
  const discountId = summerDiscountId || (isWeb17Variation ? web17_3DiscountId : undefined);
  if (discountId) {
    urlObj = new URL(
      `${getInternalCoreEndpoint()}/internal/public/checkout/${mode}/create-discount/${subscriptionPriceId}/${unlockProductId}/${trialProductId}/${discountId}`
    );
  } else {
    urlObj = new URL(
      `${getInternalCoreEndpoint()}/internal/public/checkout/${mode}/create-trial/${subscriptionPriceId}/${unlockProductId}/${trialProductId}`
    );
  }

  if (promotionCode && !discountId) {
    urlObj.searchParams.set("promotion_code", promotionCode);
  }
  urlObj.searchParams.set("ui_mode", "custom");
  urlObj.searchParams.set("tos_shown", "false");

  const emailToUse = (user?.email || "").trim();
  if (emailToUse) {
    urlObj.searchParams.set("email", sha256(emailToUse)); // Hashed for tracking
    urlObj.searchParams.set("prefillEmail", emailToUse); // Actual email for customer_email
  }

  if (user?.name) {
    urlObj.searchParams.set("name", user.name);
  }

  if (amplitudeId) {
    urlObj.searchParams.set("amplitudeId", amplitudeId);
  }

  if (eventID) {
      urlObj.searchParams.set("fb_event_id", eventID);
  }

  if (sessionIdentitySessionId) {
      urlObj.searchParams.set(
          "session_identity_session_id",
          sessionIdentitySessionId
      );
  }

  decorateUrlWithUTMParams(urlObj);

  return async () => {
    const res = await fetch(urlObj.toString(), {
      method: "GET",
    });
    const data = await res.json();
    return data.client_secret;
  };
}
